import React from 'react'

import "./Checkbox.css"

const Checkbox = ({id, required}) => {
    return ( 
        <label className="ios-checkbox">
            <input type="checkbox" id={id} name={id} required={required}/>
            <div className="checkbox-wrapper">
                <div className="checkbox-bg"></div>
                <svg fill="none" viewBox="0 0 24 24" className="checkbox-icon">
                    <path
                    strokeLinejoin="round"
                    strokeLinecap="round"
                    strokeWidth="3"
                    stroke="currentColor"
                    d="M4 12L10 18L20 6"
                    className="check-path"
                    ></path>
                </svg>
            </div>
        </label>
    );
}
 
export default Checkbox;